/**
 * Campos obligatorios de los formularios de fuentes (correo, almacenamiento, certificado): la marca junto a la
 * etiqueta, lo que falta en el orden del formulario y su resumen junto a los botones.
 */

/** Marca de campo obligatorio junto a la etiqueta. */
export const Obligatorio = () => <span aria-hidden className="text-destructive">*</span>;

/** Un dato que falta o no sirve: `que` lo nombra en el resumen junto a los botones y `error` va bajo el campo. */
export interface Falta<C extends string> { campo: C; que: string; error: string }

export const isEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

/** Junta lo que falta, en el orden del formulario. */
export function faltantes<C extends string>() {
  const lista: Falta<C>[] = [];
  return {
    lista,
    falta: (campo: C, que: string, error = `Falta ${que}.`) => { lista.push({ campo, que, error }); },
    /** Un correo: vacío solo falta si es obligatorio; escrito, debe ser válido. */
    correo(campo: C, valor: string, que: string, etiqueta: string, obligatorio: boolean) {
      if (!valor.trim()) { if (obligatorio) lista.push({ campo, que, error: `Falta ${que}.` }); }
      else if (!isEmail(valor)) lista.push({ campo, que: `un correo válido en «${etiqueta}»`, error: 'No es un correo válido.' });
    },
  };
}

export const resumen = (lista: Falta<string>[]) => `Falta ${new Intl.ListFormat('es', { type: 'conjunction' }).format(lista.map((x) => x.que))}.`;

/** La leyenda del asterisco y, si falta algo, el resumen (en rojo tras intentar guardar). */
export function ResumenFaltantes({ lista, tried }: { lista: Falta<string>[]; tried: boolean }) {
  return <p className="text-xs text-muted-foreground m-0"><Obligatorio /> Obligatorio.{lista.length > 0 && <span className={tried ? 'text-destructive' : undefined}> {resumen(lista)}</span>}</p>;
}
